//Author June Leow
//Date June 7th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, putAPICallGenerator, deleteAPICallGenerator, callBackGenerator, generateSID, getSession, formatDateTime, formatDate, confirmation, sliceFromArray} from '../../util/util';
import AppraiserFile from './appraiser-file';
import {Button, Card, NavItem, Nav, TabContent, TabPane, CardBody, CardHeader, Col, Collapse, Row,Input,Table, Modal , ModalHeader, ModalBody, UncontrolledTooltip,NavLink as NavLinkL} from 'reactstrap';
import DatePicker from 'react-datepicker';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
import MyXEditable from '../util/my-xeditable';
import {NavLink, useParams} from 'react-router-dom';
import React, {useReducer, useEffect, useRef} from 'react';
import AppraiserFee from '../appraisal/appraiser-fee';

let today = new Date();
let month = today.getMonth()+1;

if(month<10)
  month = '0'+month;

//initialize the state
const initialState = {
  appraiser:{
    messages:[],
    licenses:[],
    memo:[]
  },
  states:[
    {key:'Alabama',value:'Alabama'},{key:'Alaska',value:'Alaska'},{key:'Arizona',value:'Arizona'},{key:'Arkansas',value:'Arkansas'},{key:'California',value:'California'},{key:'Colorado',value:'Colorado'},{key:'Connecticut',value:'Connecticut'},{key:'Delaware',value:'Delaware'},{key:'Florida',value:'Florida'},{key:'Georgia',value:'Georgia'},{key:'Hawaii',value:'Hawaii'},{key:'Idaho',value:'Idaho'},{key:'Illinois',value:'Illinois'},{key:'Indiana',value:'Indiana'},{key:'Iowa',value:'Iowa'},{key:'Kansas',value:'Kansas'},{key:'Kentucky',value:'Kentucky'},{key:'Louisiana',value:'Louisiana'},{key:'Maine',value:'Maine'},{key:'Maryland',value:'Maryland'},{key:'Massachusetts',value:'Massachusetts'},{key:'Michigan',value:'Michigan'},{key:'Minnesota',value:'Minnesota'},{key:'Mississippi',value:'Mississippi'},{key:'Missouri',value:'Missouri'},{key:'Montana',value:'Montana'},{key:'Nebraska',value:'Nebraska'},{key:'Nevada',value:'Nevada'},{key:'New Hampshire',value:'New Hampshire'},{key:'New Jersey',value:'New Jersey'},{key:'New Mexico',value:'New Mexico'},{key:'New York',value:'New York'},{key:'North Carolina',value:'North Carolina'},{key:'North Dakota',value:'North Dakota'},{key:'Ohio',value:'Ohio'},{key:'Oklahoma',value:'Oklahoma'},{key:'Oregon',value:'Oregon'},{key:'Pennsylvania',value:'Pennsylvania'},{key:'Rhode Island',value:'Rhode Island'},{key:'South Carolina',value:'South Carolina'},{key:'South Dakota',value:'South Dakota'},{key:'Tennessee',value:'Tennessee'},{key:'Texas',value:'Texas'},{key:'Utah',value:'Utah'},{key:'Vermont',value:'Vermont'},{key:'Virgin Islands',value:'Virgin Islands'},{key:'Virginia',value:'Virginia'},{key:'Washington',value:'Washington'},{key:'Washington DC',value:'Washington DC'},{key:'West Virginia',value:'West Virginia'},{key:'Wisconsin',value:'Wisconsin'},{key:'Wyoming',value:'Wyoming'}
  ],
  dropdownOpen: false,
  memo:'',
  historyOrders:[],
  hasMoreOrders:true,
  sort: 'ID',
  order: 'DESC',
  limit:100,
  totalCount:0,
  offset:0,

  //existing entry of appraisal type & fee
  appraisalTypeFees:[],

  //entry of appraiser covered county/zip
  coverageCountyZip:[],

  //new appraisal type & fee entry
  newAppraisalTypeDropDownOpen:false,
  newAppraiserFileDropDownOpen:false,
  newAppraisalTypeFeeSelection:'',
  newAppraisalTypeFeeAmount:'',
  newCountyZipDropDownOpen:false,
  newArea:'',
  newAreaType:'county',
  newAreaCovered:'yes',
  appraisalTypes:[],
  preferredCommunication:[],
  fieldsEnum:[],

  newLicenseType:'Unknown',
  newLicenseNumber:'',
  newLicenseState:'',
  newLicenseExpiration:today.getFullYear()+'-'+month+'-'+today.getDate(),

  newLicenseDropDownOpen:false,
  newEmailPopUpDropDownOpen:false,
  newEmail:'',

  appraiserEmailDropDownOpen:false,
  appraiserEmailSettings:[],

  appraiserStats:[],
  activeTab:'1',

  appraiserFeeModal : false,
};

//reducer function that perform state update
const reducer = getReducer();


const Profile  = (props)=>{
  const controller = new AbortController();
  let { id, params} = useParams();
  const newsid = useRef(generateSID());
  const loading = useRef(false);
  let newInitialState = Object.assign({}, initialState, {id:id, params, params});
  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpGet = getAPICallGenerator(props, {signal:controller.signal});
  const httpPost = postAPICallGenerator(props, {signal:controller.signal});
  const httpPut = putAPICallGenerator(props, {signal:controller.signal});
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    getAppraiser();
    getAppraiserappraisalTypeFees();
    getAppraiserCoverage();
    getAppraisalTypesLabel();
    getPreferredCommunication();
    getRuleFieldEnum();
    getAppraiserStats();
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(()=>{
    if(state.historyOrders.length<=0 && state.hasMoreOrders){
      console.log('initiate load more')
      loadMore();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[state]);

  //non API call but simpyl manage state
  //render function for infinite scroller
  const renderHistoryAppraisals=()=>{
    return (
      <div>
        <Table className="table table-striped">
          <thead>
            <tr>
              <th className="cursor-pointer" width="10%" onClick={()=>columnClickHandler('reference_num')}><i className="fa fa-search"></i>&nbsp;Reference # {renderSortIcon('reference_num')}</th>
              <th className="cursor-pointer" width="10%" onClick={()=>columnClickHandler('status')}><i className="fa fa-info-circle"></i>&nbsp;Status {renderSortIcon('status')}</th>
              <th className="cursor-pointer" width="10%" onClick={()=>columnClickHandler('loan_num')}><i className="fa fa-folder"></i>&nbsp;Loan # {renderSortIcon('loan_num')}</th>
              <th className="cursor-pointer" width="10%" onClick={()=>columnClickHandler('CONCAT(borrower_f_name," ",borrower_l_name)')}><i className="fa fa-user"></i>&nbsp;Borrower {renderSortIcon('CONCAT(borrower_f_name," ",borrower_l_name)')}</th>
              <th className="cursor-pointer" width="20%" onClick={()=>columnClickHandler('property_street')}><i className="fa fa-map-marker"></i>&nbsp;Property Address {renderSortIcon('property_street')}</th>
              <th className="cursor-pointer" width="20%" onClick={()=>columnClickHandler('')}><i className="fa fa-info-circle"></i>&nbsp;Order Information {renderSortIcon('')}</th>
              <th className="cursor-pointer" width="10%" onClick={()=>columnClickHandler('datetime_submitted')}><i className="fa fa-calendar-o"></i>&nbsp;Date Submitted {renderSortIcon('datetime_submitted')}</th>
            </tr>
          </thead>
          <tbody>
          {
            state.historyOrders.map(
              (appraisal)=>{
                return (
                  <tr key={appraisal.ID}>
                    <td><NavLink className="link-color" target="_blank" to={"/appraisal/"+appraisal.ID}><b>{appraisal.reference_num}</b></NavLink></td>
                    <td>{appraisal.status}</td>
                    <td>{appraisal.loan_num}</td>
                    <td>{appraisal.borrower_f_name+' '+appraisal.borrower_l_name}</td>
                    <td>{appraisal.property_street+' '+appraisal.property_city+', '+appraisal.property_state+' '+appraisal.property_zip}</td>
                    <td>
                      <i className="fa fa-tags icon-color"></i>&nbsp;
                      {appraisal.appraisal_type}
                      <br/>
                      <i className="fa fa-home icon-color"></i>&nbsp;
                      {appraisal.property_type}
                      <br/>
                      <i className="fa fa-hashtag icon-color"></i>&nbsp;
                      {appraisal.loan_purpose}
                    </td>
                    <td>{formatDateTime(appraisal.datetime_submitted)}</td>
                  </tr>
                );
              }
            )
          }
          </tbody>
        </Table>
      </div>
    )
  }

  //click handler that switch the state of sorting order then call the function to refresh the list
  //to achieve the "sorting"
  const columnClickHandler=(col)=>{
    if(state.sort===col){
      if(state.order==='ASC')
        setState({order:'DESC'});
      else
        setState({order:'ASC'});
    }
    else
      setState({sort:col});
    refreshList();
  }

  const renderSortIcon=(col)=>{
    if(state.sort===col){
      if(state.order==='ASC')
        return <i className="red-color fa fa-arrow-down"></i>
      else
        return <i className="red-color fa fa-arrow-up"></i>
    }
  }

  const activeTabToggle=(tab)=>{
    setState({activeTab:tab});
  }

  const updateFieldCallBack=(field, value)=>{
    console.log(field, value);
    let appraiser = Object.assign({}, state.appraiser);
    appraiser[field] = value;
    setState({appraiser:appraiser});

  }

  const updateFieldCallBack2=(ID, field, value)=>{
    let appraisalTypeFees = state.appraisalTypeFees.slice();
    for(let i=0;i<appraisalTypeFees.length;i++){
      if(appraisalTypeFees[i].ID===ID){
        appraisalTypeFees[i][field] = value;
        break;
      }
    }
    setState({appraisalTypeFees:appraisalTypeFees});
  }

  const updateFieldCallBack3=(ID, field, value)=>{
    console.log(field, value);
    let appraiser = Object.assign({}, state.appraiser);
    let licenses = appraiser.licenses.slice();

    for(let i=0;i<licenses.length;i++){
      if(licenses[i].ID===ID){
        licenses[i][field] = value;
        break;
      }
    }
    appraiser.licenses = licenses;
    setState({appraiser:appraiser});
  }

  const toggleNewLicense=()=>{
    setState({newLicenseDropDownOpen:!state.newLicenseDropDownOpen});
  }

  //toggle function for pop up
  const newAappraisalTypeToggle=()=>{
    setState({newAppraisalTypeDropDownOpen:!state.newAppraisalTypeDropDownOpen});
  }

  const newCountyZipToggle=()=>{
    setState({newCountyZipDropDownOpen:!state.newCountyZipDropDownOpen});
  }

  const toggleAppraiserFeeModal = () => {
    setState({appraiserFeeModal:!state.appraiserFeeModal});
  }

  //this function refresh the list of orders pipeline
  const refreshList=()=>{
    let SID = generateSID();
    newsid.current = SID; 
    setState({historyOrders:[]});
    setState({totalCount:0});
    setState({hasMoreOrders:true});
    setState({offset:0});
  }

  //API call
  //get appraisal type
  const getAppraisalTypesLabel=()=>{
    let callBack = (response)=>{
      let code = response.data.code;
      if(code==='00'){
        let appraisalTypes = [];
        for(let i=0;i<response.data.data.length;i++){
          let tmp = {
            key: response.data.data[i].appraisal_type,
            value: response.data.data[i].appraisal_type
          }
          appraisalTypes.push(tmp);
        }
        setState({appraisalTypes:appraisalTypes});
      }
    };

    httpGet('appraisalType/label/get', '', 'Oops, something went wrong and could not load list of available report types label. Please try again later.', callBack);
  }

  const getAppraiserStats=()=>{
    const callBack = apiCallBack([{state:'appraiserStats', key:'data'}]);
    httpGet('appraiser/stats/'+getSession().userID, '', 'Oops, something went wrong and could not load appraiser\'s stats. Please try again later.', callBack);
  }

  const addNewLicense=()=>{
    let parameters = [
      {
        field:'appraiserFk',
        value:getSession().userID
      },
      {
        field:'licenseNumber',
        value:state.newLicenseNumber
      },
      {
        field:'licenseType',
        value:state.newLicenseType
      },
      {
        field:'licenseState',
        value:state.newLicenseState
      },
      {
        field:'expirationDate',
        value:state.newLicenseExpiration
      }
    ];

    let callBack = (response)=>{
      let code = response.data.code;
      if(code==='00'){
        let appraiser = Object.assign({}, state.appraiser);
        let licenses = appraiser.licenses.slice();

        licenses.push(response.data.data);
        appraiser.licenses = licenses;

        setState({appraiser:appraiser,newLicenseDropDownOpen:false});
      }
    };
    httpPost('appraiser/license/create', parameters, 'New license created successfully.', 'Oops, something went wrong and could not create the license. Please try again later.', callBack);
  }

  const deleteLicense=(id)=>{
    let appraiser = Object.assign({},state.appraiser);
    let licenses = appraiser.licenses.slice();
    licenses = sliceFromArray(licenses,'ID', id);
    appraiser.licenses = licenses;
    let callBack = apiCallBack([{state:'appraiser', value:appraiser}]);
    httpDelete('appraiser/license/'+id, 'License deleted successfull.', 'Oops, something went wrong and could not delete the license. Please try again later.', callBack);
  }
  
  //get appraiser profile
  const getAppraiser=()=>{
    let callBack = (response)=>{
      let code = response.data.code;
      if(code==='00'){
        setState({appraiser:response.data.data});
        if(response.data.data.memo!=='')
          setState({dropdownOpen:true});
      }
    };
    httpGet('appraiser/'+getSession().userID, '', 'Oops, something went wrong and could not load this appraiser profile. Please try again later.', callBack);
  }

  const getRuleFieldEnum=()=>{
    const callBack = apiCallBack([{state:'fieldsEnum', key:'data'}]);
    httpGet('autoAssign/rules/field/value', '', 'Oops, something went wrong and could not load the rule fields. Please try again later.', callBack);
  }

  const getPreferredCommunication=()=>{
    let callBack = (response)=>{
      let code = response.data.code;
      if(code==='00'){
        let preferredCommunication = [{key:'',value:'empty'}];

        for(let i=0;i<response.data.data.length;i++){
          let tmp = {}
          tmp.key=response.data.data[i].method;
          tmp.value=response.data.data[i].method;
          preferredCommunication.push(tmp);
        }
        setState({preferredCommunication:preferredCommunication});
      }
    };

    httpGet('appraiser/communicationMethod/get', '', 'Oops, something went wrong and could not load preferred communications. Please try again later.', callBack);
  }

  //get all the entries of appraisal type & fee of this appraiser
  const getAppraiserappraisalTypeFees=()=>{
    const callBack = apiCallBack([{state:'appraisalTypeFees', key:'data'}]);
    httpGet('appraiser/appraisalTypeFees/get/'+getSession().userID, '', 'Oops, something went wrong and could not load this appraiser profile. Please try again later.', callBack);
  }

  // get all the covered county and zip for the specific appraiser
  const getAppraiserCoverage=()=>{
    const callBack = apiCallBack([{state:'coverageCountyZip', key:'data'}]);
    httpGet('appraiser/coverage/get/'+getSession().userID, '', 'Oops, something went wrong and could not load this appraiser coverage county/zip. Please try again later.', callBack);
  }

  //function that fire when the infinite scroll reach bottom
  const loadMore=()=>{
    //do not load if there is no more conditions or it's loading data
    console.log(loading.current);
    console.log(state.hasMoreOrders);
    if(state.hasMoreOrders&&!loading.current){
      loading.current = true;
      let SID = newsid.current;

      //set loading equals to true so it won't fire off before we are done
      console.log('load more'+Date.now())
      console.log(loading.current)
      //callback handler that update the state when http request return
      let callBack = (response)=>{
        if(SID===newsid.current){
          let code = response.data.code;
          loading.current = false;
          if(code!=='00'){
            setState({hasMoreOrders:false});
          }
          else{
            let newOrders = response.data.data;
            let hasMoreOrders = true;
            let newOffset = state.offset;
            let totalCount = response.data.count;

            //if http request return empty then no more results, end of list
            if(newOrders.length<=0){
              hasMoreOrders = false;
            }
            else{
              //increment the offset
              newOffset = state.offset + 1;
            }

            //concat the current array of history orders
            if(state.historyOrders.length>0){
              let temp = [...state.historyOrders,...newOrders];

              setState({historyOrders:temp});
            }
            else
              setState({historyOrders:newOrders});
            console.log(hasMoreOrders)
            setState({hasMoreOrders:hasMoreOrders,offset:newOffset,totalCount:totalCount});
          }
        }
      };

      //error handler when the http request return with error
      let errorCallBack = (response)=>{
        //no more fetching data when error occur
        loading.current = false;
        setState({hasMoreOrders:false});
      };
      //collect the promise and wait for it to finish performing it's task
      httpGet('appraisal/get/history=true&limit='+state.limit+'&offset='+state.offset+'&order='+state.order+'&sort='+state.sort+'&appraiser_fk='+getSession().userID,'','Oops, something went wrong and could not load orders. Please try again later.',callBack,errorCallBack);
    }
  }

  //generate a function that do the update on editable
  const generateUpdateFunction=(url, parameters, successMessage, failedMessage, parentCallBack=null)=>{
    return (newValue, callBack, errorCallBack)=>{
      //add in the new value into parameters
      parameters.push({field:'value',value:newValue});
      let promise = httpPut(url,parameters,successMessage,failedMessage,callBack,errorCallBack);
      promise.then(
        (response)=>{
          let field;
          let value;

          for(let i=0;i<parameters.length;i++){
            if(parameters[i].field==='field')
              field = parameters[i].value;
            else if(parameters[i].field==='value')
              value = parameters[i].value;
          }
          if(parentCallBack!==null){
            parentCallBack(field, value);
          }
        }
      );
    }
  };

  //remove a single entry of appraisal type & fee
  const removeAppraisalTypeFee=(id)=>{
    let appraisalTypeFees = state.appraisalTypeFees.slice();
    appraisalTypeFees = sliceFromArray(appraisalTypeFees,'ID', id);
    let callBack = apiCallBack([{state:'appraisalTypeFees', value:appraisalTypeFees}]);
    httpDelete('appraiser/appraisalTypeFees/'+id, 'Entry removed.', 'Oops, something went wrong and failed to remove the entry, please try again later.', callBack);
  }

  //remove a single entry of county/zip
  const removeCoverage=(id)=>{
    let coverageCountyZip = state.coverageCountyZip.slice();
    coverageCountyZip = sliceFromArray(coverageCountyZip,'ID', id);
    let callBack = apiCallBack([{state:'coverageCountyZip', value:coverageCountyZip}]);
    httpDelete('appraiser/coverage/'+id, 'Entry removed.', 'Oops, something went wrong and failed to remove the entry, please try again later.', callBack);
  }

  //submit new entry of covered county
  const submitNewCoverage=(e)=>{
    e.preventDefault();
    let parameters = [
      {
        field:'appraiser_fk',
        value:getSession().userID
      },
      {
        field:'coverage_area',
        value:state.newArea
      },
      {
        field:'coverage_type',
        value:state.newAreaType
      },
      {
        field:'covered',
        value:state.newAreaCovered
      },
    ];

    let callBack = (response)=>{
      let code = response.data.code;

      if(code==='00'){
        //clear the text area
        setState({newArea:'',newAreaType:'county',newAreaCovered:'yes'});

        let coverageCountyZip = state.coverageCountyZip.slice();
        coverageCountyZip.push(response.data.data);
        setState({coverageCountyZip:coverageCountyZip});

        newCountyZipToggle();
      }
    };
    
    httpPost('appraiser/coverage/create',parameters,'New covered county/zip entry created successfully.','Oops, something went wrong and could not create this covered county/zip entry. Please try again later.',callBack);
  }

  //submit new entry of appraisal type & fee
  const submitNewAppraisalTypeFee=(e)=>{
    e.preventDefault();
    let parameters = [
      {
        field:'appraiser_fk',
        value:getSession().userID
      },
      {
        field:'label',
        value:state.newAppraisalTypeFeeSelection
      },
      {
        field:'fee',
        value:state.newAppraisalTypeFeeAmount
      }
    ];

    let callBack = (response)=>{
      let code = response.data.code;

      if(code==='00'){
        let appraisalTypeFees = state.appraisalTypeFees.slice();
        appraisalTypeFees.push(response.data.data);
        //clear the text area
        setState({newAppraisalTypeFeeAmount:'',newAppraisalTypeFeeSelection:'',appraisalTypeFees:appraisalTypeFees});
        newAappraisalTypeToggle();
      }
    };
    httpPost('appraiser/appraisalTypeFees/create',parameters,'Report type & fee entry created successfully.','Oops, something went wrong and could not create this report type & fee entry. Please try again later.',callBack);
  }

  //render
  const { appraiserStats } = state;
  let appraisalTypes;

  if(state.appraisalTypes.length>0){
    appraisalTypes = state.appraisalTypes.map(
      (appraisalType,index)=>{
        return(
          <option key={index} value={appraisalType.value}>{appraisalType.value}</option>
        );
      }
    );
  }

  let successMessage = 'Appraiser profile updated.';
  let failedMessage = 'Failed to update the value of this field, please try again later.';
  let stateWidget, billingState;

  if(state.states.length>0){
    stateWidget =
      <MyXEditable
      type="select"
      value={state.appraiser.state}
      opt={state.states}
      updateFunc={
        generateUpdateFunction('appraiser/update',[{field:'field',value:'state'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
      }
    />;

    billingState =
      <MyXEditable
      type="select"
      value={state.appraiser.billing_state}
      opt={state.states}
      updateFunc={
        generateUpdateFunction('appraiser/update',[{field:'field',value:'billing_state'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
      }
    />;
  }

  let appraisalTypeFees;

  if(state.appraisalTypeFees.length>0){
    appraisalTypeFees = state.appraisalTypeFees.map(
      (appraisalTypeFee,index)=>{
        return(
          <tr key={index}>
            <td><i className="fa fa-times cursor-pointer" onClick={()=>removeAppraisalTypeFee(appraisalTypeFee.ID)}></i></td>
            <td>{appraisalTypeFee.appraisal_type}</td>
            <td>
              <MyXEditable
              type="text"
              prefix="$"
              value={appraisalTypeFee.fee}
              updateFunc={
                generateUpdateFunction('appraiser/appraisalTypeFees/update',[{field:'field',value:'fee'},{field:'ID',value:appraisalTypeFee.ID}],successMessage, failedMessage, (field, value)=>updateFieldCallBack2(appraisalTypeFee.ID, field, value))
              }
            /></td>
          </tr>
        );
      }
    );
  }

  let coverageCountyZip;

  if(state.coverageCountyZip.length>0){
    coverageCountyZip = state.coverageCountyZip.map(
      (covered,index)=>{
        return(
          <tr key={index}>
            <td><i className="fa fa-times cursor-pointer" onClick={()=>removeCoverage(covered.ID)}></i></td>
            <td>{covered.coverage_type}</td>
            <td><b>{covered.coverage_area}</b></td>
            <td>{covered.covered==='no'?<font className="red-color">{covered.covered}</font>:<font className="green-color">{covered.covered}</font>}</td>
          </tr>
        );
      }
    );
  }


  let date = null;
  if(state.newLicenseExpiration!=='')
    date = moment(state.newLicenseExpiration).toDate();
  
  return <div className="my-well">
    <Row>
      <Col sm="6">
        <div className="page-title">
          <i className="fa fa-reorder"></i>&nbsp;Profile - {state.appraiser.first_name+" "+state.appraiser.last_name}
        </div>
      </Col>
      <Col sm="6">
      </Col>
    </Row>
    <Row>
      <Col sm="6">
        <NavLink to="/setting">Back to settings</NavLink>
      </Col>
      <Col sm="6" className='align-right'>
        {/* <NavLink to="#" onClick={toggleEmailDropDown}>Manage email notifications</NavLink><br/> */}
      </Col>
    </Row>
    <div className="my-divider"></div>
    <Nav tabs>
      <NavItem>
        <NavLinkL
          className="nav-link "
          active={state.activeTab==='1'}
          onClick={() => { activeTabToggle('1'); }}
          to="#"
        >
          Profile
        </NavLinkL>
      </NavItem>
      <NavItem>
        <NavLinkL
          className="nav-link "
          active={state.activeTab==='2'}
          onClick={() => { activeTabToggle('2'); }}
          to="#"
        >
          Fee
        </NavLinkL>
      </NavItem>
      <NavItem>
        <NavLinkL
          className="nav-link "
          active={state.activeTab==='3'}
          onClick={() => { activeTabToggle('3'); }}
          to="#"
        >
          Document Storage
        </NavLinkL>
      </NavItem>
      <NavItem>
        <NavLinkL
          className="nav-link "
          active={state.activeTab==='4'}
          onClick={() => { activeTabToggle('4'); }}
          to="#"
        >
          Order History
        </NavLinkL>
      </NavItem>
    </Nav>
    <TabContent activeTab={state.activeTab}>
      <TabPane tabId="1">
        <Card>
          <CardHeader className="header-color">
            Basic Information
          </CardHeader>
          <CardBody>
            <Row>
              <Col sm="6">
                <Row>
                  <Col sm="5">
                    Date Joined
                  </Col>
                  <Col sm="7">
                    {formatDate(state.appraiser.datetime_created)}
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Author
                  </Col>
                  <Col sm="7">
                    {state.appraiser.author}
                  </Col>
                </Row>
                <br/>
                <Row>
                  <Col sm="5">
                    First name
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.first_name}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'first_name'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Last name
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.last_name}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'last_name'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    FHA Approved
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="select"
                      opt={[{key:'yes',value:'yes'},{key:'no',value:'no'}]}
                      value={state.appraiser.fha_approved}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'fha_approved'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    ENV Ready
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="select"
                      opt={[{key:'yes',value:'yes'},{key:'no',value:'no'},{key:'unknown',value:'unknown'}]}
                      value={state.appraiser.env_ready}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'env_ready'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Desktop Appraisal Ready
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="select"
                      opt={[{key:'yes',value:'yes'},{key:'no',value:'no'},{key:'unknown',value:'unknown'}]}
                      value={state.appraiser.desktop_appraisal_ready}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'desktop_appraisal_ready'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    UAD3.6 Ready
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="select"
                      opt={[{key:'yes',value:'yes'},{key:'no',value:'no'},{key:'unknown',value:'unknown'}]}
                      value={state.appraiser.uad36_ready}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'uad36_ready'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Desk Review
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="select"
                      opt={[{key:'yes',value:'yes'},{key:'no',value:'no'},{key:'unknown',value:'unknown'}]}
                      value={state.appraiser.desk_review}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'desk_review'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Remote Appraisal Ready
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="select"
                      opt={[{key:'yes',value:'yes'},{key:'no',value:'no'},{key:'unknown',value:'unknown'}]}
                      value={state.appraiser.remote_appraisal_ready}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'remote_appraisal_ready'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Green Mortgage Experience
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="select"
                      opt={[{key:'very',value:'Very Experienced'},{key:'some',value:'Some Experienced'},{key:'no',value:'No Experience'},{key:'unknown',value:'unknown'}]}
                      value={state.appraiser.green_renovate_exp}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'green_renovate_exp'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Company name
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.company_name}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'company_name'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Make Check Payable To
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.billing_name}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'billing_name'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Email
                  </Col>
                  <Col sm="7">
                    {state.appraiser.email}
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Notify Emails
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.notify_emails}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'notify_emails'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    SMS Subscription
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="select"
                      opt={[{key:'yes',value:'yes'},{key:'no',value:'no'}]}
                      value={state.appraiser.sms_subscription}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'sms_subscription'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Office Phone
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.phone}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'phone'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Cell Phone
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.secondary_phone}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'secondary_phone'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    SMS To Phone
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="select"
                      opt={[{key:'cell',value:'cell'},{key:'office',value:'office'}]}
                      value={state.appraiser.sms_phone}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'sms_phone'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Tax ID
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.tax_id}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'tax_id'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Preferred Communications
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="select"
                      opt={state.preferredCommunication}
                      value={state.appraiser.preferred_communication}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'preferred_communication'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Vacation Start
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="date"
                      value={state.appraiser.vacation_start}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'vacation_start'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Vacation End
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="date"
                      value={state.appraiser.vacation_end}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'vacation_end'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    E&O Expiration Date
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="date"
                      value={state.appraiser.eo_expiration_date}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'eo_expiration_date'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <br/>
                <Row>
                  <Col sm="10">
                    <b>License</b>
                  </Col>
                  <Col sm="2" className="align-right">
                    <i className="fa fa-plus green-color cursor-pointer" onClick={toggleNewLicense}/>
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">

                  </Col>
                  <Col sm="2">
                    Number
                  </Col>
                  <Col sm="3">
                    Type
                  </Col>
                  <Col sm="3">
                    State
                  </Col>
                  <Col sm="3">
                    Expiration Date
                  </Col>
                </Row>
                {
                  state.appraiser.licenses.map(
                    (license, index)=>{
                      return <Row key={index}>
                        <Col sm="1">
                          <i className="fa fa-minus red-color cursor-pointer" onClick={(e)=>{
                            confirmation(
                              ()=>{deleteLicense(license.ID)},
                              ()=>{},
                              'Delete license?',
                              'Are you sure you want to delete this license?');
                          }}/>
                        </Col>
                        <Col sm="2">
                          <MyXEditable
                            type="text"
                            value={license.license_number}
                            updateFunc={
                              generateUpdateFunction('appraiser/license/update',[{field:'field',value:'license_number'},{field:'ID',value:license.ID}],successMessage, failedMessage, (field, value)=>updateFieldCallBack3(license.ID, field, value))
                            }
                          />
                        </Col>
                        <Col sm="3">
                          <MyXEditable
                            type="select"
                            opt={[{key:'Unknown',value:'Unknown'},{key:'Transitional License',value:'Transitional License'},{key:'License',value:'License'},{key:'Certified Residential',value:'Certified Residential'},{key:'Certified General',value:'Certified General'}]}
                            value={license.license_type}
                            updateFunc={
                              generateUpdateFunction('appraiser/license/update',[{field:'field',value:'license_type'},{field:'ID',value:license.ID}],successMessage, failedMessage, (field, value)=>updateFieldCallBack3(license.ID, field, value))
                            }
                          />
                        </Col>
                        <Col sm="3">
                          <MyXEditable
                          type="select"
                          value={license.license_state}
                          opt={state.states}
                          updateFunc={
                            generateUpdateFunction('appraiser/license/update',[{field:'field',value:'license_state'},{field:'ID',value:license.ID}],successMessage, failedMessage, (field, value)=>updateFieldCallBack3(license.ID, field, value))
                          }
                          />
                        </Col>
                        <Col sm="3">
                          <MyXEditable
                            type="date"
                            value={license.datetime_expiration}
                            updateFunc={
                              generateUpdateFunction('appraiser/license/update',[{field:'field',value:'datetime_expiration'},{field:'ID',value:license.ID}],successMessage, failedMessage, (field, value)=>updateFieldCallBack3(license.ID, field, value))
                            }
                          />
                        </Col>
                      </Row>
                    }
                  )
                }
                <br/>
                <Modal className="my-modal-wide" isOpen={state.newLicenseDropDownOpen} toggle={toggleNewLicense} >
                  <ModalHeader hidden={true} toggle={toggleNewLicense}></ModalHeader>
                  <ModalBody>
                    <Card>
                      <CardHeader className="header-color">
                        <i className="fa fa-reorder"></i> License
                      </CardHeader>
                      <CardBody>
                        <form onSubmit={(e)=>{e.preventDefault();addNewLicense()}}>
                          <Row>
                            <Col sm="3">
                              <label><font className="red-color">*</font>Number</label>
                              <Input type="text" required={true} onChange={(e)=>setState({newLicenseNumber:e.target.value})} value={state.newLicenseNumber}></Input>
                            </Col>
                            <Col sm="3">
                              <label><font className="red-color">*</font>State</label>
                              <Input type="select" required={true} onChange={(e)=>{setState({newLicenseState:e.target.value});}} value={state.newLicenseState}>
                                <option value="">Select a state</option>
                                {
                                  state.states.map(
                                    (state, index)=>{
                                      return <option key={index} value={state.value}>{state.value}</option>;
                                    }
                                  )
                                }
                              </Input>
                            </Col>
                            <Col sm="3">
                              <label><font className="red-color">*</font>Type</label>
                              <Input type="select" required={true} onChange={(e)=>{setState({newLicenseType:e.target.value});}} value={state.newLicenseType}>
                                <option value="Unknown">Unknown</option>
                                <option value="Transitional License">Transitional License</option>
                                <option value="License">License</option>
                                <option value="Certified Residential">Certified Residential</option>
                                <option value="Certified General">Certified General</option>
                              </Input>
                            </Col>
                            <Col sm="3">
                              <label><font className="red-color">*</font>Expiration</label><br/>
                              <DatePicker
                                className="form-control"
                                selected={date}
                                onChange={(text)=>{(text)&&setState({newLicenseExpiration:text.toLocaleDateString('en-CA')})}}
                              />
                            </Col>
                          </Row>
                          <br/>
                          <div style={{minHeight:'200px', height:'200px'}}/>
                          <center>
                            <Button color="info" onClick={toggleNewLicense}>Close</Button>
                            &nbsp;
                            <Button color="warning">Create New License</Button>
                          </center>
                        </form>
                      </CardBody>
                    </Card>
                    <br/>
                  </ModalBody>
                </Modal>
              </Col>
              <Col sm="6">
                <Row>
                  <Col sm="5">
                    Street
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.street}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'street'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    City
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.city}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'city'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    County
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.county}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'county'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    State
                  </Col>
                  <Col sm="7">
                    {stateWidget}
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Zip
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.zip}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'zip'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <br/>
                <label>Mail Check To</label>
                <Row>
                  <Col sm="5">
                    Street
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.billing_street}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'billing_street'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    City
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.billing_city}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'billing_city'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    County
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.billing_county}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'billing_county'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    State
                  </Col>
                  <Col sm="7">
                    {billingState}
                  </Col>
                </Row>
                <Row>
                  <Col sm="5">
                    Zip
                  </Col>
                  <Col sm="7">
                    <MyXEditable
                      type="text"
                      value={state.appraiser.billing_zip}
                      updateFunc={
                        generateUpdateFunction('appraiser/update',[{field:'field',value:'billing_zip'},{field:'ID',value:getSession().userID}],successMessage, failedMessage, updateFieldCallBack)
                      }
                    />
                  </Col>
                </Row>
                <br/>

                <br/>
                <Card>
                  <CardHeader className="gray-color">
                    Appraiser Coverage County/Zip
                  </CardHeader>
                  <CardBody style={{height:'450px'}}>

                    <div className="large-scroll-container">
                      <Table className="table table-striped">
                        <thead>
                          <tr>
                            <th width="5%">Action</th>
                            <th width="15%">Type</th>
                            <th width="60%">Area</th>
                            <th width="20%">Covered</th>
                          </tr>
                        </thead>
                        <tbody>
                          {coverageCountyZip}
                        </tbody>
                      </Table>
                    </div>
                    <br/>
                    <div className="align-right" style={{ display: "flex", position: "absolute", right: "10px", bottom: "10px"}}>
                      <Button color="warning" onClick={newCountyZipToggle}><i className="fa fa-plus"></i> Add</Button>
                    </div>
                    <Modal className="my-modal" isOpen={state.newCountyZipDropDownOpen} toggle={newCountyZipToggle} >
                      <ModalHeader hidden={true} toggle={newCountyZipToggle}></ModalHeader>
                      <ModalBody>
                        <center>
                          <h5><i className="fa fa-plus"></i> Add New Coverage County/Zip</h5>
                        </center>
                        <br/>
                        <form onSubmit={submitNewCoverage}>
                          <Row>
                            <Col sm="4">
                              <label>Type</label>
                              <Input required="true" type="select" value={state.newAreaType} onChange={(e)=>setState({newAreaType:e.target.value})}>
                                <option value="county">County</option>
                                <option value="zip">Zip</option>
                              </Input>
                            </Col>
                            <Col sm="4">
                              <label>Area</label>
                              <Input required="true" type="text" value={state.newArea} onChange={(e)=>setState({newArea:e.target.value})}/>
                            </Col>
                            <Col sm="4">
                              <label>Covered</label>
                              <Input required="true" type="select" value={state.newAreaCovered} onChange={(e)=>setState({newAreaCovered:e.target.value})}>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                              </Input>
                            </Col>
                          </Row>
                          <br/>
                          <br/>
                          <center>
                            <Button color="warning"><i className="green-color fa fa-plus"></i>&nbsp;Add</Button>&nbsp;
                            <Button color="info" onClick={newCountyZipToggle}>Close</Button>
                          </center>
                        </form>
                      </ModalBody>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </TabPane>
    </TabContent>
    <TabContent activeTab={state.activeTab}>
      <TabPane tabId="3">
        <Card>
          <CardHeader className="header-color">
            Document Storage
          </CardHeader>
          <CardBody style={{height:'504px'}}>
            <AppraiserFile appraiserFk={getSession().userID} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>
          </CardBody>
        </Card>
      </TabPane>
    </TabContent>
    <TabContent activeTab={state.activeTab}>
      <TabPane tabId="4">
        <Card>
          <CardHeader className="header-color">
            Order History
          </CardHeader>
          <CardBody style={{height:'650px'}}>
            <div style={{minHeight:'500px',maxHeight:'500px', overflowY:'auto'}} id="orderHistoryContainer">
              <InfiniteScroll
                className="my-well"
                dataLength={state.historyOrders.length} //This is important field to render the next data
                next={loadMore}
                hasMore={state.hasMoreOrders}
                loader={<center>Loading more new orders...</center>}
                scrollableTarget="orderHistoryContainer"
              >
                {renderHistoryAppraisals()}
              </InfiniteScroll>
            </div>
          </CardBody>
        </Card>
      </TabPane>
    </TabContent>

    <TabContent activeTab={state.activeTab}>
      <TabPane tabId="2">
        <Row>
          <Col sm="4">
            <Card>
              <CardHeader className="header-color">
                Fee & Report Type
              </CardHeader>
              <CardBody style={{height:'504px'}}>

                <div className="large-scroll-container">
                  <Table className="table table-striped">
                    <thead>
                      <tr>
                        <th width="15%">Action</th>
                        <th width="60%">Report Type</th>
                        <th width="25%">Fee</th>
                      </tr>
                    </thead>
                    <tbody>
                      {appraisalTypeFees}
                    </tbody>
                  </Table>
                </div>
                <br/>
                <div className="align-right"><Button color="warning" onClick={newAappraisalTypeToggle}><i className="fa fa-plus"></i> Add</Button></div>
                <Modal className="my-modal" isOpen={state.newAppraisalTypeDropDownOpen} toggle={newAappraisalTypeToggle} >
                  <ModalHeader hidden={true} toggle={newAappraisalTypeToggle}></ModalHeader>
                  <ModalBody>
                    <center>
                      <h5><i className="fa fa-plus"></i> Add New Report Type & Fee</h5>
                    </center>
                    <form onSubmit={submitNewAppraisalTypeFee}>
                      <label>Report Type:</label>
                      <Input required="true" type="select" value={state.newAppraisalTypeFeeSelection} onChange={(e)=>setState({newAppraisalTypeFeeSelection:e.target.value})}>
                        <option value=""></option>
                        {appraisalTypes}
                      </Input>
                      <br/>
                      <label>Fee:</label>
                      <Input required="true" type="text" value={state.newAppraisalTypeFeeAmount} onChange={(e)=>setState({newAppraisalTypeFeeAmount:e.target.value})}/>

                      <br/>
                      <center>
                        <Button color="warning"><i className="green-color fa fa-plus"></i>&nbsp;Add</Button>&nbsp;
                        <Button color="info" onClick={newAappraisalTypeToggle}>Close</Button>
                      </center>
                    </form>
                  </ModalBody>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col sm="4">
            <Card>
              <CardHeader className="header-color">
                Average Fee
              </CardHeader>
              <CardBody style={{height:'504px'}}>
                <Row>
                  <Col sm="8">
                    <label>Report Type</label>
                  </Col>
                  <Col sm="4">
                    <label>Average Fee</label>
                  </Col>
                </Row>
                {state.appraiserStats.type_fee &&
                  state.appraiserStats.type_fee.map(
                    (feeReport, index)=>{
                      return(
                        <Row>
                          <Col sm="8">
                            {feeReport['appraisal_type']}
                          </Col>
                          <Col sm="4">
                            ${feeReport['avg_fee']}
                          </Col>
                        </Row>
                      )
                    }
                  )
                }
                {!state.appraiserStats.type_fee &&<Row><Col sm="7">None</Col></Row>}
              </CardBody>
            </Card>
          </Col>
          <Col sm="4">
            <Card>
              <CardHeader className="header-color">
                Average Quote Fee
              </CardHeader>
              <CardBody style={{height:'504px'}}>
                <Row>
                  <Col sm="8">
                    <label>Report Type</label>
                  </Col>
                  <Col sm="4">
                    <label>Average Fee</label>
                  </Col>
                </Row>
                {state.appraiserStats.type_quote_fee &&
                  state.appraiserStats.type_quote_fee.map(
                    (feeReport, index)=>{
                      return(
                        <Row>
                          <Col sm="8">
                            {feeReport['appraisal_type']}
                          </Col>
                          <Col sm="4">
                            ${feeReport['avg_fee']}
                          </Col>
                        </Row>
                      )
                    }
                  )
                }
                {!state.appraiserStats.type_quote_fee &&<Row><Col sm="7">None</Col></Row>}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </TabPane>
    </TabContent>

    <Modal isOpen={state.appraiserFeeModal} toggle={() => toggleAppraiserFeeModal(null)} className="my-modal">
        <ModalBody toggle={() => toggleAppraiserFeeModal(null)}>
          <AppraiserFee appraiserID={state.appraiser.ID} appraiserEmail={state.appraiser.email} isModal={true} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>
        </ModalBody>
    </Modal>
  </div>;
}

export default Profile;